import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Remark } from 'components'
import { Table } from '@sar/component'

import { Row } from 'antd'
import { ModalForm, ProFormDatePicker } from '@ant-design/pro-components'

async function fetchData (params, store) {
  const result = await store.externals.api.get(`/split`, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

function Update ({ data, store, visible, handles, onVisibleChange }) {
  return <ModalForm
    title='修改'
    layout='vertical'
    width={400}
    open={visible}
    modalProps={{
      centered: true,
      maskClosable: false,
      destroyOnClose: true
    }}
    onOpenChange={onVisibleChange}
    request={() => store.externals.api.get(`/split/${data.id}`)}
    onFinish={params => store.externals.api.put(`/split/${data.id}`, params).then(() => handles.current.reload()).then(R.T)}
  >
    <ProFormDatePicker
      name='splitWaringTime'
      label='告警时间'
      width='xl'
      rules={[ { required: true, message: '请选择告警时间' } ]}
    />
  </ModalForm>
}

export default function ({ store, navigator }) {
  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '客户姓名' }),
    },
    {
      title: '联系电话',
      dataIndex: 'customerPhone',
      render: _ => _.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '联系电话' }),
    },
    {
      title: '地址',
      dataIndex: 'customerAddress',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '地址' }),
    },
    {
      title: '来源',
      dataIndex: 'customerSource',
    },
    {
      title: '来源',
      dataIndex: 'sourceId',
      valueType: 'treeSelect',
      hideInTable: true,
      request: () => store.externals.api.get(`/constant/source`),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ fieldNames: { value: 'id', label: 'source' }, placeholder: '来源' }),
    },
    {
      title: '拆单员',
      dataIndex: 'splitterName',
    },
    {
      title: '项目单号',
      dataIndex: 'number',
    },
    {
      title: '签单时间',
      dataIndex: 'paymentTime',
      valueType: 'date',
    },
    {
      title: '拆单时间',
      dataIndex: 'splitTime',
    },
    {
      title: '状态',
      dataIndex: 'splitStatus',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`SplitOrderStatus`),
    },
    {
      title: '拆单文件上传',
      dataIndex: 'designerFile',
      render: (_, data) => <a className='text-blue-600' onClick={() => navigator.to(`/split/list/upload/${data.id}`, `拆单文件上传`)}>{data.upSplit ? '查看' : '上传'}</a>,
    },
    {
      title: '预警时间',
      dataIndex: 'splitWaringTime',
      valueType: 'date',
    },
  ]

  const rowActions = [
    {
      name: '修改',
      form: props => <Update {...props} store={store} />,
      visible: () => store.identity.hasPermission('/split/list:update'),
    },
    {
      name: '查看备注',
      form: props => <Remark {...props}/>,
    },
    {
      name: '确定',
      confirmType: 'modal',
      confirmMessage: '确定后订单会进入下一环节，将不可更改。',
      visible: () => store.identity.hasPermission('/split/list:submit'),
      onConfirm: (data, handles) => store.externals.api.put(`/split/submit/${data.id}`).then(() => handles.current.reload()),
    }
  ]

  const cols = React.useMemo(() => {
    let showSearch = [
        'customerName'
      , 'customerAddress'
      , 'customerPhone'
      , 'sourceId'
    ]

    return columns.map(column => {
      if (showSearch.includes(column.dataIndex)) {
        return Object.assign(column)
      }

      else {
        return Object.assign(column, { hideInSearch: true })
      }
    })
  }, [])

  return <div className='p-4'>
    <Table
      title='拆单列表'
      columns={cols}
      rowActions={rowActions}
      request={params => fetchData(params, store)}
      scroll={{ }}
      search={{ labelWidth: 'auto', defaultCollapsed: true, span: Object.assign({}, store.config.responsive, { xxl: 4 }) }}
    />
  </div>
}
